import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {WeeeSystemService} from '../../../services/weee-system.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Countries} from '../../../models/countries.interface';
import {WeeeSystems} from '../../../models/weee_systems.interface';

@Component({
  selector: 'app-create-weee-system',
  templateUrl: './create-weee-system.component.html',
  styleUrls: ['./create-weee-system.component.scss']
})
export class CreateWeeeSystemComponent implements OnInit {

  weeeSystemCreateForm = this.formBuilder.group({
    description: ['', Validators.required],
    country: ['', Validators.required],
    member: [false]
  });

  get descriptionControl(): FormControl {
    return this.weeeSystemCreateForm.get('description') as FormControl;
  }
  get countryControl(): FormControl {
    return this.weeeSystemCreateForm.get('country') as FormControl;
  }
  get memberControl(): FormControl {
    return this.weeeSystemCreateForm.get('member') as FormControl;
  }

  @Output()
  createEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(private dialogRef: MatDialogRef<CreateWeeeSystemComponent>,
              @Inject(MAT_DIALOG_DATA) public data: Countries[],
              private readonly formBuilder: FormBuilder,
              private readonly weeeSystemService: WeeeSystemService) { }

  ngOnInit(): void {
  }

  sendCreationRequest(): void {
    const dto: WeeeSystems | null = this.getCreationDto();
    if (dto) {
      this.weeeSystemService.createWeeeSystem(dto).subscribe(
        () => {
          this.createEvent.emit();
          this.closeDialog();
        },
        () => {
          this.closeDialog();
        }
      );
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private getCreationDto(): WeeeSystems {
    return {
      description: this.descriptionControl.value,
      country: this.countryControl.value,
      isMember: this.memberControl.value,
    };
  }

}
